export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const LOAD_CURRENT_ITEM = 'LOAD_CURRENT_ITEM';
export const UPDATE_QTY = 'UPDATE_QTY'